import React, {FC, useMemo} from 'react'
import {Box} from 'exsportia-components'
import {SessionCard} from '../session-card/session-card'
import {SessionSelectSession} from '../../api/class-session/types'
import {useLocale, useLuxon} from '../../utils/i18n'
import {messagesByReason} from '../../pages/schedule/shedule'
import {NO_USER_PHOTO} from '../../utils/remote-content'
import {CurrenciesEnum} from '../../types/currencies'

type Props = {
  session: SessionSelectSession
  venueData?: {
    currency?: CurrenciesEnum | string
  }
  variant: 'waitingListBooked' | 'waitingListAvailable' | 'default'
  isMemberLoading?: boolean
  isLoading?: boolean
  isPast?: boolean
}

export const WaitingListSessionInfo: FC<Props> = ({
  session,
  venueData,
  variant,
  isMemberLoading = false,
  isLoading = false,
  isPast = false,
}) => {
  const {l} = useLocale()
  const luxon = useLuxon()

  const instructorName = useMemo(() => {
    if (!session.instructors || session.instructors.length === 0) {
      return ''
    }
    return session.instructors.map((i) => i.name).join(', ')
  }, [session.instructors])

  const instructorImage = session.instructors?.[0]?.profileImage?.secure_url ?? NO_USER_PHOTO

  return (
    <Box
      borderRadius='12px'
      background='background-secondary'
      width='100%'
    >
      <SessionCard
        time={luxon.fromMillis(session.timestamp).toUTC().toFormat('HH:mm')}
        price={session.price}
        currency={venueData?.currency as any}
        disabled={true}
        className={session.className}
        variant={variant}
        isLoading={isMemberLoading || isLoading}
        disabledText={isPast ? 'past' : (messagesByReason(session.permissionData?.reason) as any)}
        participants={session.showParticipants ? session.participants : null}
        availableSpots={session.availableSlots}
        instructorName={instructorName}
        instructorImage={instructorImage}
        isSessionAlreadyBooked={session.isSessionAlreadyBooked}
        duration={l('minutes_short', {
          value: session.duration,
        })}
      />
    </Box>
  )
}
